import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';

@Feature()
export class UndoFeature extends BaseToolbarFeature {
    id = config.id;
    constructor() {
        super();
    }
}
